import React, { FC, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button, { ButtonProps } from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

type LinkButtonProps = {
  to: string;
  label: string;
  tooltip?: string;
  withPathname?: boolean;
  component?: React.ElementType;
} & ButtonProps;

const LinkButton: FC<LinkButtonProps> = ({ to, label, tooltip, withPathname, ...props }) => {
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (!location) return;

    const isCurrentLocation =
      to === '/' ? location.pathname === to : location.pathname.includes(to);
    setIsActive(isCurrentLocation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const generateLink = location && withPathname ? `${location.pathname}/${to}` : to;

  const ButtonComponent = (
    <Button component={Link} to={generateLink} color={isActive ? 'primary' : undefined} {...props}>
      {label}
    </Button>
  );

  return tooltip ? (
    <Tooltip title={tooltip} placement="top">
      {ButtonComponent}
    </Tooltip>
  ) : (
    ButtonComponent
  );
};

export default LinkButton;
